var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import React from 'react';
import { inject, observer } from 'mobx-react';
import moment from "moment";
import { createForm } from "rc-form";
import { withFormItem } from 'fe-toolkit';
import { AutoComplete, GroupInput } from '@components';
import { AccountBusiness } from '@business/account/login';
import classnames from 'classnames';
import { currentClientNameById, getClientContact } from '@common/utils/userProfile';
import { getUrlParams } from '@common/utils/url';
import { Dialog, Loader } from 'oned';
import { debounce } from 'lodash-es';
import './index.less';
import { isMobile, sendAmplitude_Otp } from '@common/utils';
import { AmplitudeEventName } from '@common/enums/base';
import { formatPhoneNumber } from '@common/utils/format';
var FormInput = withFormItem(GroupInput);
var FormAutoCompleteInput = withFormItem(AutoComplete);
var defaultValue = {
    addressLine1: '',
    address1Loader: false,
    address1List: [],
    addressLine2: '',
    city: '',
    cityList: [],
    cityLoader: false,
    state: '',
    stateList: [],
    stateLoader: false,
    zipcode: '',
    existingPhone: '',
    isLoading: false,
    residentDetails: [],
    selectedResident: {
        residentId: '',
        name: '',
        phone: '',
        displayPhone: '',
        generatedBgColor: ''
    },
    isSecondStep: false,
    errorMsg: '',
    eventId: '',
    callCenter: '',
    showDialog: false
};
var radioButtonStyle = {
    gridColumn: '3',
    gridRow: '1',
    alignSelf: 'center',
    justifySelf: 'end'
};
var VerifyLocation = /** @class */ (function (_super) {
    __extends(VerifyLocation, _super);
    function VerifyLocation(props) {
        var _this = _super.call(this, props) || this;
        _this.onSubmit = function () {
            var _a = _this.props, getResidentContactListByLocation = _a.getResidentContactListByLocation, form = _a.form, clientInfo = _a.clientInfo, history = _a.history;
            var _b = _this.state, isLoading = _b.isLoading, addressLine1 = _b.addressLine1, addressLine2 = _b.addressLine2, city = _b.city, zipcode = _b.zipcode, existingPhone = _b.existingPhone, eventId = _b.eventId, state = _b.state;
            var jumpTime = 5000;
            form.validateFields({ force: true }, function (errors) {
                if (errors) {
                    var instance = form.getFieldInstance(Object.keys(errors)[0]);
                    instance.focus && instance.focus();
                    return;
                }
                _this.setState({ isLoading: true });
                var stateAbbr = state.split('-')[0];
                var request = { addressLine1: addressLine1, addressLine2: addressLine2, city: city, zipcode: zipcode, requestedPhone: existingPhone, clientCode: "", eventId: eventId, state: stateAbbr };
                getResidentContactListByLocation(request).then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                    var _this = this;
                    return __generator(this, function (_a) {
                        switch (_a.label) {
                            case 0:
                                if (data === undefined || data.length === 0) {
                                    history.push('/account/verifyOtpError');
                                }
                                return [4 /*yield*/, $('#step1').fadeOut(500)];
                            case 1:
                                _a.sent();
                                data.map(function (x) {
                                    x.generatedBgColor = _this.getRandomBGColor();
                                });
                                this.setState({ isLoading: false, residentDetails: data, isSecondStep: true });
                                $('#step2').removeClass('d-none').hide().fadeIn(500);
                                return [2 /*return*/];
                        }
                    });
                }); }).catch(function (error) {
                    history.push('/account/verifyOtpError');
                });
            });
        };
        _this.getResidentAddressList = debounce(_this.getResidentAddress, 500);
        _this.getResidentCityList = debounce(_this.getResidentCity, 500);
        _this.getResidentStateList = debounce(_this.getResidentState, 500);
        _this.handleAddressAutoCompleteSearch = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ addressLine1: e });
                if (e.length < 2) {
                    this.setState({ address1List: [] });
                }
                else {
                    this.getResidentAddressList();
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleCityAutoCompleteSearch = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ city: e });
                if (e.length < 2) {
                    this.setState({ cityList: [] });
                }
                else {
                    this.getResidentCityList();
                }
                return [2 /*return*/];
            });
        }); };
        _this.handleStateAutoCompleteSearch = function (e) { return __awaiter(_this, void 0, void 0, function () {
            return __generator(this, function (_a) {
                this.setState({ state: e });
                if (e.length < 2) {
                    this.setState({ stateList: [] });
                }
                else {
                    this.getResidentStateList();
                }
                return [2 /*return*/];
            });
        }); };
        _this.signInByResident = function () {
            var _a = _this.props, history = _a.history, sendOtpToPhone = _a.sendOtpToPhone;
            var _b = _this.state, selectedResident = _b.selectedResident, eventId = _b.eventId;
            _this.setState({ isLoading: true, errorMsg: '' });
            var encodedPhone = btoa("000000" + selectedResident.displayPhone);
            var request = {
                clientCode: '',
                residentId: selectedResident.residentId,
                phone: selectedResident.phone,
                isPhoneEncrypted: true,
                eventId: eventId
            };
            sendOtpToPhone(request).then(function (data) { return __awaiter(_this, void 0, void 0, function () {
                return __generator(this, function (_a) {
                    if (data !== undefined && data.isSuccess) {
                        history.push("/account/verifyOtp?contact=" + encodedPhone + "&residentId=" + selectedResident.residentId + "&isPhoneEnc=" + selectedResident.phone + "&eventId=" + eventId);
                        sendAmplitude_Otp(this.props.residentInfo, AmplitudeEventName.OTP_Transition_SelectResidentContinue_To_Verify);
                    }
                    this.setState({ errorMsg: 'Cannot send OTP. Please try again.', isLoading: false });
                    return [2 /*return*/];
                });
            }); }).catch(function (error) {
                _this.setState({ errorMsg: 'Cannot send OTP. Please try again.', isLoading: false });
            });
        };
        _this.state = defaultValue;
        return _this;
    }
    VerifyLocation.prototype.componentDidMount = function () {
        return __awaiter(this, void 0, void 0, function () {
            var data, phoneNumber, getCallCenterPhone, tel, contactInfo;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        data = getUrlParams();
                        if (data !== undefined && data.contact !== undefined) {
                            phoneNumber = atob(data.contact);
                            if (phoneNumber.length === 10) {
                                this.setState({ existingPhone: phoneNumber });
                            }
                        }
                        if (data != undefined && data.eventId !== undefined) {
                            this.setState({ eventId: data.eventId });
                        }
                        getCallCenterPhone = this.props.getCallCenterPhone;
                        return [4 /*yield*/, getCallCenterPhone()];
                    case 1:
                        tel = _a.sent();
                        if (tel !== null) {
                            this.setState({ callCenter: tel.replace(/\D/g, ''), isLoading: false });
                        }
                        else {
                            contactInfo = getClientContact().tel;
                            this.setState({ callCenter: contactInfo, isLoading: false });
                        }
                        sendAmplitude_Otp(this.props.residentInfo, AmplitudeEventName.OTP_Transition_PhoneContinue_To_Address);
                        return [2 /*return*/];
                }
            });
        });
    };
    VerifyLocation.prototype.onContactUs = function () {
        var callCenter = this.state.callCenter;
        if (isMobile) {
            window.location.href = "tel:" + callCenter;
        }
        else {
            this.setState({ showDialog: true });
        }
    };
    VerifyLocation.prototype.handlePrimaryAddressSelection = function (value) {
        this.setState({ addressLine1: value, address1List: [] });
    };
    VerifyLocation.prototype.getResidentAddress = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getResidentAddress, addressLine1, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ address1Loader: true });
                        getResidentAddress = this.props.getResidentAddress;
                        addressLine1 = this.state.addressLine1;
                        return [4 /*yield*/, getResidentAddress(addressLine1)];
                    case 1:
                        data = _a.sent();
                        if (data !== undefined) {
                            this.setState({ address1List: data.map(function (x) { return x.name; }) });
                        }
                        this.setState({ address1Loader: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    VerifyLocation.prototype.getResidentCity = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getResidentCity, city, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ cityLoader: true });
                        getResidentCity = this.props.getResidentCity;
                        city = this.state.city;
                        return [4 /*yield*/, getResidentCity(city)];
                    case 1:
                        data = _a.sent();
                        if (data !== undefined) {
                            this.setState({ cityList: data.map(function (x) { return x.name; }) });
                        }
                        this.setState({ cityLoader: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    VerifyLocation.prototype.getResidentState = function () {
        return __awaiter(this, void 0, void 0, function () {
            var getResidentState, state, data;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        this.setState({ stateLoader: true });
                        getResidentState = this.props.getResidentState;
                        state = this.state.state;
                        return [4 /*yield*/, getResidentState(state)];
                    case 1:
                        data = _a.sent();
                        if (data !== undefined) {
                            this.setState({ stateList: data.map(function (x) { return x.name; }) });
                        }
                        this.setState({ stateLoader: false });
                        return [2 /*return*/];
                }
            });
        });
    };
    VerifyLocation.prototype.handleCitySelection = function (value) {
        this.setState({ city: value, cityList: [] });
    };
    VerifyLocation.prototype.handleStateSelection = function (value) {
        this.setState({ state: value, stateList: [] });
    };
    VerifyLocation.prototype.setSelectedResident = function (resident) {
        this.setState({ selectedResident: resident });
    };
    VerifyLocation.prototype.getNamePrefix = function (name) {
        if (name === undefined) {
            return 'N/A';
        }
        var names = name.split(' ');
        if (names.length > 0) {
            var firstName = names[0];
            var lastName = names[names.length - 1];
            return "" + firstName[0].toUpperCase() + lastName[0].toUpperCase();
        }
        return 'N/A';
    };
    VerifyLocation.prototype.getRandomBGColor = function () {
        var letters = '0123456789ABCDEF';
        var color = '#';
        for (var i = 0; i < 6; i++) {
            color += letters[Math.floor(Math.random() * 16)];
        }
        return color;
    };
    VerifyLocation.prototype.resetFilters = function () {
        this.setState(__assign({}, defaultValue));
    };
    VerifyLocation.prototype.onBack = function () {
        return __awaiter(this, void 0, void 0, function () {
            var isSecondStep;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        isSecondStep = this.state.isSecondStep;
                        if (!!isSecondStep) return [3 /*break*/, 1];
                        history.back();
                        return [3 /*break*/, 3];
                    case 1:
                        this.resetFilters();
                        return [4 /*yield*/, $('#step2').fadeOut(500).addClass('d-none')];
                    case 2:
                        _a.sent();
                        this.setState({ isLoading: false });
                        $('#step1').removeClass('d-none').hide().fadeIn(500);
                        _a.label = 3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    VerifyLocation.prototype.render = function () {
        var _this = this;
        var _a = this.props, form = _a.form, clientInfo = _a.clientInfo;
        var _b = this.state, callCenter = _b.callCenter, showDialog = _b.showDialog, address1List = _b.address1List, address1Loader = _b.address1Loader, addressLine1 = _b.addressLine1, city = _b.city, cityList = _b.cityList, cityLoader = _b.cityLoader, residentDetails = _b.residentDetails, isLoading = _b.isLoading, selectedResident = _b.selectedResident, errorMsg = _b.errorMsg, state = _b.state, stateList = _b.stateList, stateLoader = _b.stateLoader;
        return React.createElement(React.Fragment, null,
            React.createElement(Loader, { visible: isLoading, page: true }),
            React.createElement("div", { className: "login-flex" },
                React.createElement("div", { className: "login-page" },
                    React.createElement("button", { className: "navbar-toggler text-large go-back-small-screen", type: "button", onClick: function () {
                            _this.onBack();
                            sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Back);
                        } },
                        React.createElement("span", { className: "iconfont icon-return", style: { fontSize: '14px' } }),
                        "Back"),
                    React.createElement("div", { className: "customer-logo" }),
                    React.createElement("div", { className: "login-box", id: "step1" },
                        React.createElement("button", { className: "navbar-toggler text-small go-back-big-screen", type: "button", style: { padding: '0', paddingBottom: '10px' }, onClick: function () {
                                _this.onBack();
                                sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Back);
                            } },
                            React.createElement("span", { className: "iconfont icon-return", style: { fontSize: '10px' } }),
                            "Back"),
                        React.createElement("div", { id: "verifyByLocation" },
                            React.createElement("h5", { className: "text-left mt-2" },
                                "The phone number entered does not match a property with ",
                                currentClientNameById(parseInt(clientInfo.clientId)),
                                ". Please enter your property information to select the address from the drop down to verify your account."),
                            React.createElement("div", { className: "panel-body" },
                                React.createElement("div", { className: "form-group" },
                                    React.createElement(FormAutoCompleteInput, { value: addressLine1, prop: "addressLine1", label: "Address 1", format: true, form: form, maxlength: "225", placeholder: "Address 1", rules: [{ required: true, message: 'This field is required' }], type: "text", autoCompleteList: address1List, loader: address1Loader, onChange: function (val) {
                                            _this.handleAddressAutoCompleteSearch(val);
                                        }, onSelection: function (val) {
                                            _this.handlePrimaryAddressSelection(val);
                                        }, onClose: function () { return _this.setState({ address1List: [] }); } }),
                                    React.createElement(FormInput, { value: this.state.addressLine2, onChange: function (val) {
                                            _this.setState({ addressLine2: val });
                                        }, prop: "addressLine2", label: "Address 2 (optional)", format: true, form: form, maxlength: "225", placeholder: "Address 2" }),
                                    React.createElement(FormAutoCompleteInput, { value: city, prop: "city", label: "City", format: true, form: form, maxlength: "225", placeholder: "City", rules: [{ required: true, message: 'This field is required' }], type: "text", autoCompleteList: cityList, loader: cityLoader, onChange: function (val) {
                                            _this.handleCityAutoCompleteSearch(val);
                                        }, onSelection: function (val) {
                                            _this.handleCitySelection(val);
                                        }, onClose: function () { return _this.setState({ cityList: [] }); } }),
                                    React.createElement(FormAutoCompleteInput, { value: state, prop: "state", label: "State", format: true, form: form, maxlength: "225", placeholder: "State", rules: [{ required: true, message: 'This field is required' }], type: "text", autoCompleteList: stateList, loader: stateLoader, onChange: function (val) {
                                            _this.handleStateAutoCompleteSearch(val);
                                        }, onSelection: function (val) {
                                            _this.handleStateSelection(val);
                                        }, onClose: function () { return _this.setState({ stateList: [] }); } }),
                                    React.createElement(FormInput, { value: this.state.zipcode, onChange: function (val) {
                                            _this.setState({ zipcode: val });
                                        }, prop: "zipcode", label: "Zip code", format: true, rules: [{ required: true, message: 'This field is required' }], form: form, maxlength: "5", placeholder: "00000" })),
                                React.createElement("a", { href: "javascript:void(0)", className: classnames("btn btn-submit btn-block"), id: "continueLocation", onClick: function () {
                                        _this.onSubmit();
                                        sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_AddressContinue);
                                    } }, "Continue")))),
                    React.createElement("div", { className: "login-box d-none", id: "step2" },
                        React.createElement("button", { className: "navbar-toggler text-small go-back-big-screen", type: "button", style: { padding: '0', paddingBottom: '10px' }, onClick: function () {
                                _this.onBack();
                                sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_Back);
                            } },
                            React.createElement("span", { className: "iconfont icon-return", style: { fontSize: '10px' } }),
                            "Back"),
                        React.createElement("h5", { className: "text-left mt-2" }, "Choose an account to continue"),
                        React.createElement("div", { className: "panel-body" },
                            residentDetails.map(function (item) { return (React.createElement("div", { className: "card mb-4" },
                                React.createElement("div", { className: "card-body", style: { padding: '0.5rem' } },
                                    React.createElement("div", { className: "verify-resident-grid", onClick: function () {
                                            _this.setSelectedResident(item);
                                            sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_SelectResident);
                                        } },
                                        React.createElement("div", { className: "avatarStyle", style: { backgroundColor: item.generatedBgColor } }, _this.getNamePrefix(item.name)),
                                        React.createElement("div", { className: "verify-resident-name", style: { gridRow: '1 / span 1' } },
                                            React.createElement("b", null, item.name)),
                                        React.createElement("div", { className: "verify-resident-name", style: { gridRow: '2 / span 1' } },
                                            "(***) *** ",
                                            item.displayPhone,
                                            " "),
                                        React.createElement("div", { style: radioButtonStyle },
                                            React.createElement("input", { type: "radio", name: item.phone, checked: selectedResident.residentId === item.residentId })))))); }),
                            React.createElement("button", { className: classnames("btn btn-submit btn-block"), id: "continueLocationOtp", disabled: selectedResident.residentId.length === 0, onClick: function () {
                                    _this.signInByResident();
                                    sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_SelectResidentContinue);
                                } }, "Continue"),
                            errorMsg && React.createElement("p", { style: { marginTop: '-1rem' } },
                                React.createElement("i", { className: "help-block text-danger" }, errorMsg)),
                            React.createElement("div", { className: "form-group", style: { textAlign: 'center', marginTop: '5%' } },
                                React.createElement("a", { style: { padding: '5px', textAlign: 'center', marginTop: '5%' }, onClick: function () { _this.onContactUs(); sendAmplitude_Otp(_this.props.residentInfo, AmplitudeEventName.OTP_Click_ContactUs); } }, "Not in the list? Contact Us")))),
                    React.createElement("p", { className: "text-muted text-center" },
                        "\u00A9 ",
                        moment().utc().year(),
                        " Lessen, LLC. All Rights Reserved.")),
                React.createElement(Dialog, { visible: showDialog, title: "Contact Us", closable: true, destroyOnClose: false, onClose: function () { return _this.setState({ showDialog: false }); }, animation: "zoom", maskClosable: true, maskAnimation: "fade", hasFooter: false, className: "hack-dialog" },
                    React.createElement("div", { className: "text-middle pb-4" },
                        "Please contact our customer service at ",
                        formatPhoneNumber(callCenter),
                        " for assistance."))));
    };
    VerifyLocation = __decorate([
        createForm(),
        inject(AccountBusiness),
        observer
    ], VerifyLocation);
    return VerifyLocation;
}(React.Component));
export default VerifyLocation;
